import { render, staticRenderFns } from "./TravelsCumulativeEmissions.vue?vue&type=template&id=69ec3baa&scoped=true"
import script from "./TravelsCumulativeEmissions.vue?vue&type=script&lang=js"
export * from "./TravelsCumulativeEmissions.vue?vue&type=script&lang=js"
import style0 from "./TravelsCumulativeEmissions.vue?vue&type=style&index=0&id=69ec3baa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69ec3baa",
  null
  
)

export default component.exports